/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Estimated credit usage and cost for billing
 * @export
 * @interface CreditEstimate
 */
export interface CreditEstimate {
    /**
     * 
     * @type {number}
     * @memberof CreditEstimate
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof CreditEstimate
     */
    companyId: number;
    /**
     * Generic resource ID for auditing (e.g., documentId, comparisonId)
     * @type {number}
     * @memberof CreditEstimate
     */
    relatedId?: number | null;
    /**
     * Type of related resource (e.g., 'document', 'comparison', 'supplement')
     * @type {string}
     * @memberof CreditEstimate
     */
    relatedType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreditEstimate
     */
    estimatedCredits: number;
    /**
     * 
     * @type {number}
     * @memberof CreditEstimate
     */
    estimatedCostCents: number;
    /**
     * 
     * @type {string}
     * @memberof CreditEstimate
     */
    tierCode: CreditEstimateTierCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreditEstimate
     */
    source: CreditEstimateSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreditEstimate
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CreditEstimate
     */
    pages?: number | null;
}


/**
 * @export
 */
export const CreditEstimateTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type CreditEstimateTierCodeEnum = typeof CreditEstimateTierCodeEnum[keyof typeof CreditEstimateTierCodeEnum];

/**
 * @export
 */
export const CreditEstimateSourceEnum = {
    DocParse: 'doc_parse',
    Compare: 'compare',
    Supplement: 'supplement',
    Other: 'other'
} as const;
export type CreditEstimateSourceEnum = typeof CreditEstimateSourceEnum[keyof typeof CreditEstimateSourceEnum];


/**
 * Check if a given object implements the CreditEstimate interface.
 */
export function instanceOfCreditEstimate(value: object): value is CreditEstimate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('estimatedCredits' in value) || value['estimatedCredits'] === undefined) return false;
    if (!('estimatedCostCents' in value) || value['estimatedCostCents'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function CreditEstimateFromJSON(json: any): CreditEstimate {
    return CreditEstimateFromJSONTyped(json, false);
}

export function CreditEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditEstimate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'relatedId': json['relatedId'] == null ? undefined : json['relatedId'],
        'relatedType': json['relatedType'] == null ? undefined : json['relatedType'],
        'estimatedCredits': json['estimatedCredits'],
        'estimatedCostCents': json['estimatedCostCents'],
        'tierCode': json['tierCode'],
        'source': json['source'],
        'createdAt': (new Date(json['createdAt'])),
        'pages': json['pages'] == null ? undefined : json['pages'],
    };
}

export function CreditEstimateToJSON(json: any): CreditEstimate {
    return CreditEstimateToJSONTyped(json, false);
}

export function CreditEstimateToJSONTyped(value?: Omit<CreditEstimate, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'relatedId': value['relatedId'],
        'relatedType': value['relatedType'],
        'estimatedCredits': value['estimatedCredits'],
        'estimatedCostCents': value['estimatedCostCents'],
        'tierCode': value['tierCode'],
        'source': value['source'],
        'pages': value['pages'],
    };
}

